var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeRedLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(-848 -699) translate(848 699)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B72B44",
    d: "M18.125 8.667h-.938V6.762C17.188 4.133 15.088 2 12.5 2 9.912 2 7.812 4.133 7.812 6.762v1.905h-.937C5.844 8.667 5 9.524 5 10.57v9.524C5 21.143 5.844 22 6.875 22h11.25C19.156 22 20 21.143 20 20.095v-9.524c0-1.047-.844-1.904-1.875-1.904zm0 10.476c0 .524-.422.952-.938.952H7.813c-.515 0-.937-.428-.937-.952v-7.62c0-.523.422-.952.938-.952h9.375c.515 0 .937.429.937.953v7.619zM12.5 17.238c-1.031 0-1.875-.857-1.875-1.905 0-1.047.844-1.904 1.875-1.904 1.031 0 1.875.857 1.875 1.904 0 1.048-.844 1.905-1.875 1.905zM9.687 8.667V6.762c0-1.581 1.257-2.857 2.813-2.857 1.556 0 2.813 1.276 2.813 2.857v1.905H9.686z",
    transform: "translate(-848 -699) translate(848 699)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeRedLock);
export default __webpack_public_path__ + "static/media/large-red-lock.322aaed91763daad266717a6ea1cca6b.svg";
export { ForwardRef as ReactComponent };